/* eslint-disable react/no-array-index-key */
import { ReactNode } from 'react';

import { lodash, range } from 'helpers';
import { Box } from 'libs/ui';

import { Section, SectionProps } from '../Section';

import { FieldsStyled } from './OrderSection.styles';

export interface OrderSectionProps extends SectionProps {
  fields: ReactNode[];

  afterContent?: ReactNode;
  afterFields?: ReactNode;
}

export const OrderSection = ({
  afterContent,
  afterFields,
  fields,
  ...sectionProps
}: OrderSectionProps) => (
  <Section {...sectionProps}>
    {afterContent}

    {lodash.chunk(fields, 3).map((fieldsChunk) => (
      <FieldsStyled>
        {fieldsChunk.map((content, index) => (
          <Box key={index} flex={1}>
            {content}
          </Box>
        ))}
        {fieldsChunk.length < 3 &&
          range(3 - fieldsChunk.length).map(() => (
            <div className="orderSection-emptySpace" />
          ))}
      </FieldsStyled>
    ))}
    {afterFields}
  </Section>
);
